module.exports = __webpack_public_path__ + "static/media/circle-minus.8be120d7.svg";